import { createContext, useContext } from 'react';

type ProviderSearchFiltersContextType = {
  selectedState: string | null;
  selectedInsurance: string | null;
};

export const ProviderSearchFiltersContext =
  createContext<ProviderSearchFiltersContextType>({
    selectedState: null,
    selectedInsurance: null,
  });

export const useProviderSearchFilters = () =>
  useContext(ProviderSearchFiltersContext);
